import script from "./AuthModalInput.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthModalInput.vue?vue&type=script&setup=true&lang=js"

import "./AuthModalInput.vue?vue&type=style&index=0&id=addb525e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-addb525e"]])

export default __exports__